import { render, staticRenderFns } from "./DeliveryZiti.vue?vue&type=template&id=7cc63e76&scoped=true&"
import script from "./DeliveryZiti.vue?vue&type=script&lang=js&"
export * from "./DeliveryZiti.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryZiti.vue?vue&type=style&index=0&id=7cc63e76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc63e76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\CRM\\Client2026\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cc63e76')) {
      api.createRecord('7cc63e76', component.options)
    } else {
      api.reload('7cc63e76', component.options)
    }
    module.hot.accept("./DeliveryZiti.vue?vue&type=template&id=7cc63e76&scoped=true&", function () {
      api.rerender('7cc63e76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cms/delivery/components/DeliveryZiti.vue"
export default component.exports